import get from 'lodash.get'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { notifyStoryStarted, notifyStoryEnded, updateContextStates } from './ReaderManagerSlice'
export default function ReaderManagerEvents(props) {

    const { readingMode, currentStoryId, currentWord, currentPhrase, currentAccuracy, storyStarted, storyInProgress, minTimeElapsed, storyEnded, currentStory, currentWordsCorrect, phraseEnded, detections } = props

    const dispatch = useDispatch()

    useEffect(() => {

        dispatch(updateContextStates({
            readingMode,
            currentWord,
            currentPhrase,
            currentAccuracy,
            currentStory,
            currentStoryId,
            currentWordsCorrect,
            minTimeElapsed,
            phraseEnded,
        }))

    }, [props])

    useEffect(() => {

        if(detections && detections.length){
            const backgroundNoiseDetector = detections.find( detector => detector && detector.detector === 'background_noise_detector_v2')
            const snrDetector = detections.find( detector => detector && detector.detector === "SnrDetector")
            dispatch(updateContextStates({
                snrTriggered: snrDetector && snrDetector.triggered,
                bgNoiseTriggered: backgroundNoiseDetector && backgroundNoiseDetector.triggered,
                detectionEnded: true
            }))
        }
        
    }, [detections])

    useEffect(() => {
        dispatch(notifyStoryStarted(storyStarted))
        dispatch(notifyStoryEnded(storyEnded))
    }, [storyInProgress])

    return null
}
